import { render, staticRenderFns } from "./kolpross.vue?vue&type=template&id=ab13ec26&scoped=true"
import script from "./kolpross.vue?vue&type=script&lang=js"
export * from "./kolpross.vue?vue&type=script&lang=js"
import style0 from "./kolpross.vue?vue&type=style&index=0&id=ab13ec26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab13ec26",
  null
  
)

export default component.exports